export default "__VITE_ASSET__D7pYK3Qy__"